import React from "react";
import { useNavigate } from "react-router-dom";
import "./DestinationViewMore.css";
import agra from "../../assets/agra.png";
import backwaters from "../../assets/backwaters.png";
import jaipur from "../../assets/jaipur.png";
import delhi from "../../assets/delhi.png";
import varanasi from "../../assets/varanasi.png";
import goa from "../../assets/goa.png";
import kashmir from "../../assets/kashmir.png";
import ladakh from "../../assets/ladakh.png";
import jaisalmer from "../../assets/jaisalmer.png";
import hampi from "../../assets/hampi.png";
import mysore from "../../assets/mysore.png";
import ooty from "../../assets/ooty.png";
import manali from "../../assets/manali.png";
import darjeeling from "../../assets/darjeeling.png";
import kochi from "../../assets/kochi.png";

const Destination = [
  {
    name: "Agra",
    image: agra,
    description:
      "Iconic white marble mausoleum and UNESCO World Heritage Site, symbol of love.",
    link: "/tour-package-data",
  },
  {
    name: "Jaipur",
    image: jaipur,
    description:
      "The Pink City known for royal palaces, forts, and vibrant markets.",
    link: "/tour-package-data",
  },
  {
    name: "Backwaters",
    image: backwaters,
    description:
      "Serene network of canals and lagoons; famous for houseboat cruises.",
    link: "/tour-package-data",
  },
  {
    name: "Delhi",
    image: delhi,
    description: "Capital city blending historic monuments and modern culture.",
    link: "/tour-package-data",
  },
  {
    name: "Varanasi",
    image: varanasi,
    description:
      "Spiritual city on the Ganges, known for its ghats and cultural heritage.",
    link: "/tour-package-data",
  },
  {
    name: "Goa",
    image: goa,
    description:
      "Coastal state known for beaches, nightlife, and Portuguese heritage.",
    link: "/tour-package-data",
  },
  {
    name: "Kashmir",
    image: kashmir,
    description:
      "Breathtaking mountain landscapes, lakes, and adventure activities.",
    link: "/tour-package-data",
  },
  {
    name: "Ladakh",
    image: ladakh,
    description:
      "High-altitude desert with stunning lakes and Buddhist monasteries.",
    link: "/tour-package-data",
  },
  {
    name: "Jaisalmer",
    image: jaisalmer,
    description:
      "The Golden City in the Thar Desert; famous for forts and camel safaris.",
    link: "/tour-package-data",
  },
  {
    name: "Hampi",
    image: hampi,
    description:
      "UNESCO World Heritage site with ancient ruins and temple complexes.",
    link: "/tour-package-data",
  },
  {
    name: "Mysor",
    image: mysore,
    description:
      "City known for its royal heritage, palaces, and cultural festivals.",
    link: "/tour-package-data",
  },
  {
    name: "Ooty",
    image: ooty,
    description:
      "Hill station in the Nilgiris, famous for botanical gardens and scenic views.",
    link: "/tour-package-data",
  },
  {
    name: "Manali",
    image: manali,
    description:
      "Popular Himalayan resort town with adventure and nature experiences.",
    link: "/tour-package-data",
  },
  {
    name: "Daejeeling",
    image: darjeeling,
    description:
      "Famous for tea gardens, toy train, and views of Mount Kanchenjunga.",
    link: "/tour-package-data",
  },
  {
    name: "Kochi",
    image: kochi,
    description:
      "Cultural hub with historic sites, Chinese fishing nets, and art festivals.",
    link: "/tour-package-data",
  },
];

const DestinationViewMore = () => {
  const navigate=useNavigate()
  return (
    <div>
      <div className="destination-exploremore-main-div">
        {Destination.map((user) => (
          <div
            className="destination-explore-more-card"
            onClick={() =>
              navigate(user.link, {
                state: { title: user.name },
              })
            }
          >
            <div
              className="destination-explore-more-img"
              style={{ backgroundImage: `url(${user.image})` }}
            >
              <span
                style={{
                  marginLeft: [
                    "Ooty",
                    "Goa",
                    "Kochi",
                    "Agra",
                    "Delhi",
                  ].includes(user.name)
                    ? "50px"
                    : "0",
                }}
              >
                {user.name}
              </span>
            </div>

            <p>{user.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DestinationViewMore;
